// extracted by mini-css-extract-plugin
export default {"table":"estimate_table_table__8vaYR","nofile":"estimate_table_nofile__JLz7p","xbtn":"estimate_table_xbtn__UYkTR","btnText":"estimate_table_btnText__2DGok"};